import React from "react";
import { Table } from "antd";

const PatientRecordTable = (props) => {
  const { columns, data } = props;

  return (
    <Table
      className="components-table-demo-nested"
      columns={columns}
      dataSource={data}
      size="middle"
    />
  );
};

export default PatientRecordTable;
